export default __webpack_public_path__ + "static/char-s-59-ja-79e6fcfe9c7e58057ec6b81368579549.webp";